<template>
  <div 
    v-observe-visibility="{
      callback: this.visibilityChanged,
      throttle: 100
    }"
    id="home"
    data-id="0"
    class="section"
  >
    <div class="border-grid">
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'SectionHome',
  props: ['visibilityChanged']
}
</script>
<style lang="scss" scoped>
  .section{
    position: relative;
    width: 100%;
    margin: 0 auto;
    max-width: 1440px;
    padding-bottom: 0px;
    overflow: hidden;
    &#home{
      .center{
        
        @media screen and (max-width: 900px ){
          
        }
      }
    }
    .border-grid{
      position: absolute;
      height: 100%;
      left: 25%;
      right: 25%;
      border-left: 1px solid rgba($color: #000000, $alpha: 0.05);
      border-right: 1px solid rgba($color: #000000, $alpha: 0.05);
      .inner-line {
        position: absolute;
        left: 50%;
        height: 100%;
        border-left: 1px solid rgba($color: #000000, $alpha: 0.05);
      }
      @media screen and( max-width: 1100px) {
        left: 15%;
        right: 15%;
      }
      @media screen and( max-width: 900px) {
        left: 20px;
        right: 20px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// SectionHome.vue?3b2e896e